// @ts-nocheck
/**
 * Embla Carousel — initialisation unifiée.
 * Desktop (≥768px) : Embla avec flèches et dots.
 * Mobile (<768px)  : scroll natif snap + dots synchronisés via event scroll.
 */

var MOBILE_BP = 768;
function isMobile() { return window.innerWidth < MOBILE_BP; }

/* ══════════════════════════════════════════════════════
   0. HELPERS DOTS (communs desktop + mobile)
   ══════════════════════════════════════════════════════ */

function buildDots(root, count) {
  var labelTemplate = root.dataset.dotsLabel || '__INDEX__';
  root.querySelectorAll('[data-dots-auto]').forEach(function(container) {
    var group = container.dataset.dotGroup || '';
    container.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'c-dot' + (i === 0 ? ' c-dot--active' : '');
      btn.setAttribute('data-embla-dot', '');
      if (group) btn.setAttribute('data-dot-group', group);
      btn.setAttribute('data-index', String(i));
      btn.setAttribute('aria-label', labelTemplate.replace('__INDEX__', String(i + 1)));
      btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      container.appendChild(btn);
    }
  });
}

function buildAutoDots(root, embla) {
  buildDots(root, embla.scrollSnapList().length);
}

function updateDotGroupByIndex(root, group, activeIndex) {
  var selector = group
    ? '[data-embla-dot][data-dot-group="' + group + '"]'
    : '[data-embla-dot]:not([data-dot-group])';
  var dots = root.querySelectorAll(selector);
  if (!dots.length) return;
  var activeDot = Math.min(activeIndex, dots.length - 1);
  dots.forEach(function(dot, i) {
    var active = i === activeDot;
    dot.classList.toggle('c-dot--active', active);
    dot.setAttribute('aria-current', active ? 'true' : 'false');
  });
}

/* ══════════════════════════════════════════════════════
   1. MOBILE — scroll natif
   ══════════════════════════════════════════════════════ */

function initMobileNativeScroll(root) {
  var viewport = root.querySelector('.embla__viewport');
  var container = root.querySelector('.embla__container');
  if (!viewport || !container) return;

  var slides = Array.from(container.children);
  if (slides.length <= 1) return;

  buildDots(root, slides.length);

  // Dot click → scroll vers le slide correspondant
  root.querySelectorAll('[data-embla-dot]').forEach(function(dot) {
    dot.addEventListener('click', function() {
      var index = parseInt(dot.getAttribute('data-index') || '0', 10);
      var slide = slides[index];
      if (slide) viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    });
  });

  // Synchronisation des dots au scroll natif
  // getBoundingClientRect() donne la position relative à la fenêtre →
  // la différence slide.left - viewport.left est exacte quel que soit le offsetParent.
  var scrollTimer;
  viewport.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      var vpLeft = viewport.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDist = Infinity;
      slides.forEach(function(slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - vpLeft);
        if (dist < closestDist) { closestDist = dist; closestIndex = i; }
      });
      updateDotGroupByIndex(root, 'mobile', closestIndex);
      updateDotGroupByIndex(root, '', closestIndex);
    }, 40);
  });

  root.dataset.emblaInitialized = 'true';
}

/* ══════════════════════════════════════════════════════
   2. DESKTOP — Embla
   ══════════════════════════════════════════════════════ */

function initDesktopEmbla(root) {
  const Embla = window.EmblaCarousel;
  if (typeof Embla !== 'function') return;

  const viewport = root.querySelector('.embla__viewport');
  if (!viewport) return;

  const container = root.querySelector('.embla__container');
  const slideCount = container ? container.children.length : 0;
  if (slideCount <= 1) return;

  const embla = Embla(viewport, {
    loop: false,
    align: 'start',
    containScroll: 'trimSnaps',
    slidesToScroll: 1,
  }, []);

  buildAutoDots(root, embla);

  function attachDotClicks() {
    root.querySelectorAll('[data-embla-dot]').forEach(function(dot) {
      dot.addEventListener('click', function() {
        embla.scrollTo(parseInt(dot.getAttribute('data-index') || '0', 10));
      });
    });
  }
  attachDotClicks();

  const prevBtns = root.querySelectorAll('[data-embla-prev]');
  const nextBtns = root.querySelectorAll('[data-embla-next]');

  function updateUi() {
    prevBtns.forEach(function(btn) { btn.disabled = !embla.canScrollPrev(); });
    nextBtns.forEach(function(btn) { btn.disabled = !embla.canScrollNext(); });
    var snap = embla.selectedScrollSnap();
    updateDotGroupByIndex(root, 'desktop', snap);
    updateDotGroupByIndex(root, 'mobile', snap);
    updateDotGroupByIndex(root, '', snap);
  }

  prevBtns.forEach(function(btn) {
    btn.addEventListener('click', function() { embla.scrollPrev(); });
  });
  nextBtns.forEach(function(btn) {
    btn.addEventListener('click', function() { embla.scrollNext(); });
  });

  embla.on('select', updateUi);
  embla.on('init', updateUi);
  embla.on('reInit', function() {
    buildAutoDots(root, embla);
    attachDotClicks();
    updateUi();
  });
  updateUi();

  root.dataset.emblaInitialized = 'true';

  var emblaWrapper = root.querySelector('.embla');
  if (emblaWrapper) emblaWrapper.classList.add('is-embla-ready');

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() { embla.reInit(); }, 150);
  });
}

/* ══════════════════════════════════════════════════════
   3. POINT D'ENTRÉE
   ══════════════════════════════════════════════════════ */

function initPushCardEmbla(root) {
  if (root.dataset.emblaInitialized === 'true') return;

  if (isMobile()) {
    initMobileNativeScroll(root);
  } else {
    initDesktopEmbla(root);
  }
}

function initAllPushCards() {
  document.querySelectorAll('[data-push-card-embla]').forEach(initPushCardEmbla);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllPushCards);
} else {
  initAllPushCards();
}

document.addEventListener('shopify:section:load', function(e) {
  var container = e.target;
  if (container && typeof container.querySelectorAll === 'function') {
    container.querySelectorAll('[data-push-card-embla]').forEach(initPushCardEmbla);
  }
});
